import React from 'react';
import { VoteSingleSelect } from './type/VoteSingleSelect';
import { VoteMultiSelect } from './type/VoteMultiSelect';
import { VoteRanked } from './type/VoteRanked';
import { VoteQuestionnaire } from './type/VoteQuestionnaire';
import { VoteSurvey } from './type/VoteSurvey';
import dompurify from 'dompurify';
import { VoteIBPSA } from './type/VoteIBPSA';
import { VoteCategories } from '../../types/voteTypes';

export const VoteGroup = ({ currentGroup, currentGroupVote, handleOptionsUpdate, ballot, isJustSubmitted, setSubmitVisible }) => {
    return (
        <>
            {currentGroup.groupDescription &&
                <div className="mb-4">
                    <span dangerouslySetInnerHTML={{ __html: dompurify.sanitize(currentGroup.groupDescription) }} />
                </div>
            }
            {(currentGroup.groupType === VoteCategories.BallotSingle || currentGroup.groupType === VoteCategories.ExhaustiveBallot
                || currentGroup.groupType === VoteCategories.SwimmingAustraliaResolution) &&
                <VoteSingleSelect options={currentGroup.options}
                    hasVoted={currentGroupVote.hasVoted && !ballot.isVoteChange}
                    onOptionsUpdate={handleOptionsUpdate}
                    group={currentGroup} />}
            {currentGroup.groupType.startsWith("BallotMulti") &&
                <VoteMultiSelect options={currentGroup.options}
                    hasVoted={currentGroupVote.hasVoted && !ballot.isVoteChange}
                    onOptionsUpdate={handleOptionsUpdate}
                    group={currentGroup} />}
            {(currentGroup.groupType.startsWith("Ranked") || currentGroup.groupType === VoteCategories.SwimmingAustraliaDirectors) &&
                <VoteRanked options={currentGroup.options}
                    hasVoted={currentGroupVote.hasVoted && !ballot.isVoteChange}
                    onOptionsUpdate={handleOptionsUpdate}
                    group={currentGroup} />}
            {currentGroup.groupType === VoteCategories.Questionnaire &&
                <VoteQuestionnaire options={currentGroup.options}
                    hasVoted={currentGroupVote.hasVoted && !ballot.isVoteChange}
                    onOptionsUpdate={handleOptionsUpdate} />}
            {(currentGroup.groupType === VoteCategories.Survey || currentGroup.groupType === VoteCategories.AGMMotion) &&
                <VoteSurvey options={currentGroup.options}
                    hasVoted={currentGroupVote.hasVoted && !ballot.isVoteChange}
                    onOptionsUpdate={handleOptionsUpdate} />}
            {currentGroup.groupType === VoteCategories.IBPSA &&
                <VoteIBPSA options={currentGroup.options}
                    hasVoted={currentGroupVote.hasVoted && !ballot.isVoteChange}
                    onOptionsUpdate={handleOptionsUpdate}
                    group={currentGroup} />}
        </>
    );
}